var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment_methods"},[(_vm.blockUI)?_c('BlockUI',{attrs:{"message":"Prosimo počakajte trenutek...","url":"/images/loading-spinner.svg"}}):_vm._e()],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bed17d7e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modules/PaymentMethodsBS3.vue
// module id = YyLz
// module chunks = 0